export enum DatabaseProperty {
  DATABASE_NAME = 'database.name',
  DATABASE_ONLINE = 'database.online',
  REASONING_SCHEMAS = 'reasoning.schemas',
  REASONING_SCHEMA_GRAPHS = 'reasoning.schema.graphs',
  SENSITIVE_PROPERTIES = 'security.properties.sensitive',
  SENSITIVE_PROPERTY_GROUPS = 'security.properties.sensitive.groups',
}
